<template>
  <!-- <div class="BlockList">
    <div class="BlockListbg">
      <div class="BlockList-W">
        <img
          class="imgs"
          src="../../../assets/pc/Login/close.png"
          @click="close"
        />
        <div class="logintit">Sign in</div>
        <div class="loginbox">
          <el-form ref="form" :model="form" :rules="rules">
            <div class="putext">
              <el-form-item prop="email">
                <el-input
                  v-model="form.email"
                  class="inpttext"
                  placeholder="Email"
                ></el-input>
              </el-form-item>
            </div>

            <div class="putext">
              <el-form-item prop="password">
                <el-input
                  v-model="form.password"
                  type="password"
                  show-password
                  class="inpttext"
                  placeholder="Password"
                ></el-input>
              </el-form-item>
            </div>
            <div class="logins" @click="login">OK</div>
            <div class="signup" @click="signup">Sign Up</div>
          </el-form>
        </div>
      </div>
    </div>
  </div> -->
  <div id="About1">
    <div class="Main-W">
      <div class="Aboutbg">
        <div class="Aboutitle">TO BECOME</div>
        <div class="Aboutcon">
          <span>A</span> knowledgeable Web<span>3</span> <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;accredite<span>d</span> investo<span
            >r</span
          >
        </div>
        <div class="Aboutcon1">Fund</div>
        <div class="BlockList-W">
          <!-- <img
            class="imgs"
            src="../../../assets/pc/Login/close.png"
            @click="close"
          /> -->
          <div class="imgs"></div>
          <div class="logintit">Sign in</div>
          <div class="loginbox">
            <el-form ref="form" :model="form" :rules="rules">
              <div class="putext">
                <el-form-item prop="userName">
                  <el-input
                    v-model="form.userName"
                    class="inpttext"
                    placeholder="userName"
                  ></el-input>
                </el-form-item>
              </div>

              <div class="putext">
                <el-form-item prop="password">
                  <el-input
                    v-model="form.password"
                    type="password"
                    show-password
                    class="inpttext"
                    placeholder="Password"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="logins" @click="login">OK</div>
              <!-- <div class="signup" @click="signup">Sign Up</div> -->
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetAlogin } from "@/assets/server/api";

export default {
  props: ["flog", "flogb"],
  data() {
    return {
      auserId: "",
      form: {
        userName: "",
        password: "",
      },
      rules: {
        userName: [
          {
            required: true,
            message: "userName  is required",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: {},
  created() {
    this.auserId = localStorage.getItem("auserId");
   // console.log(this.auserId);
  },
  mounted() {
    // if (
    //   this.auserId !== "" ||
    //   this.auserId !== null ||
    //   this.auserId !== undefined
    // ) {
    //   this.$router.push('/pc/Index');
    // }else{
    //   this.$router.push('/pc/Login');
    // }
  },
  watch: {
    $route: {
      handler: function (to, form) {
        if (to.path === "/pc/Index") {
          //  console.log(111);
          if (localStorage.getItem("auserId") == null) {
            this.$router.push("/pc/Login");
          } else {
             this.$router.push("/pc/Index");
          //   this.$router.push({
          //   path: "/pc/Index",
          //   query: { auserId: this.auserId },
          // });
          }
        }
      },
      flog(val) {
        this.floag = val;
      },
      flogb(val) {
        console.log(val);
        this.floagb = val;
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    close() {
      this.floag = false;
      this.$emit("loginflog", this.floag);
    },
    signup() {
      // this.floag = false;
      this.floagb = true;
      // this.$emit("loginflog", this.floag);
      this.$emit("signups", this.floagb);
    },
    //点击进行账号登录
    async login() {
      //   console.log(this.form.code);
      // this.onVerifySuccess();
      // if (this.isVerify == false) {
      //   this.$message("Captcha is required");
      //   return false;
      // } else {
      //   console.log();
      //   this.onVerifySuccess();

      // }
      this.$refs.form.validate(async (success) => {
        //    if (this.validatePassword()) {
        //console.log(this.form);
        if (success) {
          const params = {
            userName: this.form.userName,
            password: this.form.password,
          };
          const formData = new FormData();
          const item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          let data = await GetAlogin(formData);
         //console.log(data);
          if (data.code == 200) {
           // console.log("登录成功");
            localStorage.setItem("auserId", data.result);
            this.$router.push("/pc/Index");
          //   this.$router.push({
          //   path: "/pc/Index",
          //   query: { auserId:data.result }
          // });
          } else {
            // this.$message(data.result);
            this.$message({
              message: data.result,
              type: "warning",
              customClass: "message-zindex",
            });
          }
        } else {
          // this.$message(" This field are not filled in ");
          this.$message({
            message: data.result,
            type: "warning",
            customClass: "message-zindex",
          });
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
  background: #000;
  width: 100%;
  height: 1012px;
  margin: 0 auto;
  overflow: auto;
  .BlockListbg {
    background: url("../../../assets/pc/Index/banner.png") center/cover
      no-repeat;
    width: 1560px;
    height: 1013px;
    position: relative;
    .BlockList-W {
      width: 365px;
      height: 355px;
      background: #151515;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      position: absolute;
      z-index: 0 !important;
      // border: 1px solid red;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .imgs {
        width: 18px;
        height: 18px;
        margin-left: 335px;
        margin-top: 12px;
      }
      .logintit {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 22px;
        color: #ffffff;
        line-height: 33px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: 10px;
      }
      .loginbox {
        width: 305px;
        margin: 0 auto;
        margin-top: 36px;
        .putext {
          /deep/.el-input__inner {
            border: none;
            background: #151515;
            border-bottom: 1px solid #5b5b5b;
            padding-bottom: 10px;
            padding-left: 0px;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 16px;
            color: #fff;
            padding-left: 12px;
          }
          /deep/.el-input__inner::placeholder {
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.3);
          }
        }
        .logins {
          width: 305px;
          height: 38px;
          background: #3cf6f0;
          border-radius: 81px 81px 81px 81px;
          text-align: center;
          line-height: 38px;
          margin-top: 60px;
          cursor: pointer;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 15px;
          color: #151515;
        }
        .signup {
          text-align: center;
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          margin-top: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
#About1 {
  background: #000;
  width: 100%;
  height: 1012px;
  margin: 0 auto;
  // padding-top: 68px;
  .Main-W {
    width: 1560px;
    margin: 0 auto;
    background: #000;
    .Aboutbg {
      background: url(../../../assets/pc/Index/banner.png) center/cover
        no-repeat;
      width: 1560px;
      height: 1013px;
      position: relative;
      .Aboutitle {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 30px;
        color: #ffffff;
        position: absolute;
        left: 227px;
        top: 307px;
      }
      .Aboutcon {
        position: absolute;
        top: 355px;
        font-family: Poppins-ExtraBold;
        font-weight: 800;
        font-size: 100px;
        color: #ffffff;
        left: 146px;
        span {
          filter: blur(4px);
        }
      }
      .Aboutcon1 {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 30px;
        color: #ffffff;
        position: absolute;
        top: 629px;
        left: 1170px;
      }
      .BlockList-W {
        width: 365px;
        height: 355px;
        background: #151515;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        position: absolute;
        z-index: 0 !important;
        // border: 1px solid red;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .imgs {
          width: 18px;
          height: 18px;
          margin-left: 335px;
          margin-top: 12px;
        }
        .logintit {
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 22px;
          color: #ffffff;
          line-height: 33px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-top: 10px;
        }
        .loginbox {
          width: 305px;
          margin: 0 auto;
          margin-top: 36px;
          .putext {
            /deep/.el-input__inner {
              border: none;
              background: #151515;
              border-bottom: 1px solid #5b5b5b;
              padding-bottom: 10px;
              padding-left: 0px;
              font-family: Poppins, Poppins;
              font-weight: 400;
              font-size: 16px;
              color: #fff;
            }
            /deep/.el-input__inner::placeholder {
              font-family: Poppins, Poppins;
              font-weight: 400;
              font-size: 16px;
              color: rgba(255, 255, 255, 0.3);
            }
          }
          .logins {
            width: 305px;
            height: 38px;
            background: #3cf6f0;
            border-radius: 81px 81px 81px 81px;
            text-align: center;
            line-height: 38px;
            margin-top: 60px;
            cursor: pointer;
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 15px;
            color: #151515;
          }
          .signup {
            text-align: center;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            margin-top: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
